import { render, staticRenderFns } from "./RmaForm.vue?vue&type=template&id=1ec79625"
import script from "./RmaForm.vue?vue&type=script&lang=js"
export * from "./RmaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports